import React, { SVGProps } from 'react'
const SvgArrowBack = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="m7.31 13.25 4.72 4.72a.75.75 0 0 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 1.06l-4.72 4.72H18.5a.75.75 0 0 1 0 1.5H7.31Z"
    />
  </svg>
)
export default SvgArrowBack
